import { Dispatch, Action } from 'redux'
import { WorkspaceSubscriptionMainMapDispatchReturnType } from './types/WorkspaceSubscriptionMainMapDispatchReturnType'

export const WorkspaceSubscriptionMainMapDispatch = (
  _dispatch: Dispatch<Action>
): WorkspaceSubscriptionMainMapDispatchReturnType => {
  return {}
}
